// extracted by mini-css-extract-plugin
module.exports = {"notStore":"dG6wU","prodInfo":"BGnfQ","infoRight":"_1T3gP","link":"_1a4dA","supplier":"_3Sq-a","price":"_1U667","footer":"_3SObL","comment":"_2fQYN"};